/**
 * @name printPdfKioskSafe
 * @param {string} pdfBytes - File in base64 string format
 * @description Print a pdf file using a stable approach that works in kiosk mode, avoiding the printJS.
 */
export const printPdfKioskSafe = (pdfBytes) => {
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);

  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.right = "0";
  iframe.style.bottom = "0";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";

  let cleaned = false;

  const cleanup = () => {
    if (cleaned) return;
    cleaned = true;

    try {
      URL.revokeObjectURL(url);
      iframe.remove();
    } catch (e) {
      console.warn("Print cleanup failed:", e);
    }
  };

  iframe.onload = () => {
    try {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } catch (err) {
      console.error("Print error:", err);
    }

    // Silent print has no reliable event → fallback cleanup
    setTimeout(cleanup, 10000);
  };

  iframe.onerror = cleanup;

  iframe.src = url;
  document.body.appendChild(iframe);
};
